// A notification carries the screen it opens. That value comes from stored data, so only an address on
// this site (one slash, then a path) is followed; anything else (another site, "//host", "javascript:",
// a backslash or a hidden control character that a browser would read as a slash) is ignored and the
// caller falls back to its own default.
const ORIGIN_PROBE = "http://route-check.invalid";

export function safeAppRoute(route) {
  if (typeof route !== "string" || !/^\/(?![/\\])[^\s\\\u0000-\u001f]*$/.test(route)) return null;
  try {
    return new URL(route, ORIGIN_PROBE).origin === ORIGIN_PROBE ? route : null;
  } catch {
    return null;
  }
}
